import React from 'react';
import { ChevronRight } from '@menuzen/icon/build/outline';
import { useEditor } from '@mnz/builder';

import Dialog, { DialogProps } from '../../../../components/dialog/Dialog';

interface ColoursModalProps extends DialogProps {
    onSelectItem: (type: string) => void;
}

const isGradientColor = (color: string) => {
    if (!color) {
        return '';
    }
    return color.includes('linear-gradient');
};

const ColorsModal: React.FC<ColoursModalProps> = ({ onSelectItem, ...props }) => {
    const { designSettings } = useEditor((_, query) => ({
        designSettings: query.getDesignSettings(),
    }));

    const textColor = designSettings?.colors?.text;
    const buttonColor = designSettings?.colors?.button;
    const buttonTextColor = designSettings?.colors?.buttonText;
    const socialButtonBackground = designSettings?.colors?.socialButton;

    return (
        <Dialog {...props}>
            <div className="pt-20 pb-40">
                <div className={`px-30`}>
                    <div
                        className="flex items-center justify-start rounded-8 border border-primary-40 py-10 px-15 mb-10"
                        onClick={() => onSelectItem('text')}
                    >
                        <div
                            className="h-35 w-35 rounded-5 border border-primary-40 mr-8"
                            style={{ background: textColor?.color }}
                        />
                        <div className="flex-grow flex flex-col items-start justify-between">
                            <div className="text-16 leading-none">Text</div>
                            <div className="text-14 leading-none text-primary-70 mt-4">
                                {isGradientColor(textColor?.color as string) ? 'Gradient' : textColor?.color}
                            </div>
                        </div>
                        <div className="text-20 text-primary-50">
                            <ChevronRight />
                        </div>
                    </div>
                    <div
                        className="flex items-center justify-start rounded-8 border border-primary-40 py-10 px-15 mb-10"
                        onClick={() => onSelectItem('button')}
                    >
                        <div
                            className="h-35 w-35 rounded-5 border border-primary-40 mr-8"
                            style={{ background: buttonColor?.color }}
                        />
                        <div className="flex-grow flex flex-col items-start justify-between">
                            <div className="text-16 leading-none">Button</div>
                            <div className="text-14 leading-none text-primary-70 mt-4">
                                {isGradientColor(buttonColor?.color as string) ? 'Gradient' : buttonColor?.color}
                            </div>
                        </div>
                        <div className="text-20 text-primary-50">
                            <ChevronRight />
                        </div>
                    </div>
                    <div
                        className="flex items-center justify-start rounded-8 border border-primary-40 py-10 px-15 mb-10"
                        onClick={() => onSelectItem('buttonText')}
                    >
                        <div
                            className="h-35 w-35 rounded-5 border border-primary-40 mr-8"
                            style={{ background: buttonTextColor?.color }}
                        />
                        <div className="flex-grow flex flex-col items-start justify-between">
                            <div className="text-16 leading-none">Button Text</div>
                            <div className="text-14 leading-none text-primary-70 mt-4">
                                {isGradientColor(buttonTextColor?.color as string)
                                    ? 'Gradient'
                                    : buttonTextColor?.color}
                            </div>
                        </div>
                        <div className="text-20 text-primary-50">
                            <ChevronRight />
                        </div>
                    </div>
                    <div
                        className="flex items-center justify-start rounded-8 border border-primary-40 py-10 px-15"
                        onClick={() => onSelectItem('socialButton')}
                    >
                        <div
                            className="h-35 w-35 rounded-5 border border-primary-40 mr-8"
                            style={{ background: socialButtonBackground?.color }}
                        />
                        <div className="flex-grow flex flex-col items-start justify-between">
                            <div className="text-16 leading-none">Social Buttons</div>
                            <div className="text-14 leading-none text-primary-70 mt-4">
                                {isGradientColor(socialButtonBackground?.color as string)
                                    ? 'Gradient'
                                    : socialButtonBackground?.color}
                            </div>
                        </div>
                        <div className="text-20 text-primary-50">
                            <ChevronRight />
                        </div>
                    </div>
                </div>
            </div>
        </Dialog>
    );
};

export default ColorsModal;
